import React from 'react';
import GenericReportModal from './GenericReportModal';
import SupplierPriceListReportMutation from 'graphql/mutations/supplier/SupplierPriceListReportMutation.graphql';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import { AlertType } from '../../graphql/schema/p4types';
import { useActionCriteria } from '../../utils/useActionProps';
import { useP4ToastController } from '../../views/system/NotificationsArea';

const templateFilters = [
  {
    filterOperation: 'EQUALS',
    filterParameters: {
      field: 'reportType',
      value: 'SUPPLIER_PRICE_LIST',
    },
  },
];

const SupplierPriceListModal = (props) => {
  const { dispatchSimpleAlert } = useP4ToastController();

  const actionProps = useActionCriteria();
  if (Array.isArray(actionProps.actionEntities)) {
    actionProps.actionEntities = normalizeVariables(actionProps.actionEntities, ['priceOriginDescription']);
  }

  if (actionProps.include && actionProps.actionEntities?.length < 1) {
    props.onClose();
    dispatchSimpleAlert('Unable to print', 'No rows have been selected', AlertType.Warning);

    return null;
  }

  const input = () => {
    return {
      ...actionProps,
      supplier: props.supplier,
    };
  };

  return (
    <GenericReportModal
      allowEmailTo={true}
      templateFilters={templateFilters}
      input={input}
      title="Supplier PRICE LIST"
      mutation={SupplierPriceListReportMutation}
      {...props}
    />
  );
};

export default SupplierPriceListModal;
